module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "sessao-imovel"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', [_c('icon', {
    attrs: {
      "name": "home"
    }
  }), _vm._v(" Dados do imóvel")], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-2"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.residence.zip_code')
    }
  }, [_vm._m(0, false, false), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##.###-###'),
      expression: "'##.###-###'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.residence.zip_code),
      expression: "residence.zip_code"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.residence.zip_code",
      "id": "zip_code",
      "type": "text",
      "data-vv-as": "CEP"
    },
    domProps: {
      "value": (_vm.residence.zip_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.residence, "zip_code", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('data.residence.zip_code')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.residence.zip_code')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-8"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.residence.street')
    }
  }, [_vm._m(1, false, false), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.residence.street),
      expression: "residence.street"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true }}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.residence.street",
      "id": "imovel_logradouro",
      "type": "text",
      "data-vv-as": "Logradouro"
    },
    domProps: {
      "value": (_vm.residence.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.residence, "street", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('data.residence.street')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.residence.street')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-2"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.residence.number')
    }
  }, [_vm._m(2, false, false), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.residence.number),
      expression: "residence.number"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.residence.number",
      "id": "imovel_numero",
      "type": "text",
      "data-vv-as": "Número"
    },
    domProps: {
      "value": (_vm.residence.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.residence, "number", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('data.residence.number')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.residence.number')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.residence.complement')
    }
  }, [_c('label', {
    attrs: {
      "for": "imovel_complemento"
    }
  }, [_vm._v("Complemento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.residence.complement),
      expression: "residence.complement"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.residence.complement",
      "id": "imovel_complemento",
      "type": "text",
      "data-vv-as": "Complemento"
    },
    domProps: {
      "value": (_vm.residence.complement)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.residence, "complement", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('data.residence.complement')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.residence.complement')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.residence.neighborhood')
    }
  }, [_vm._m(3, false, false), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.residence.neighborhood),
      expression: "residence.neighborhood"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true }}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.residence.neighborhood",
      "id": "imovel_bairro",
      "type": "text",
      "data-vv-as": "Bairro"
    },
    domProps: {
      "value": (_vm.residence.neighborhood)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.residence, "neighborhood", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('data.residence.neighborhood')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.residence.neighborhood')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.residence.cidade')
    }
  }, [_vm._m(4, false, false), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.residence.city),
      expression: "residence.city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true }}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "data.residence.cidade",
      "id": "imovel_cidade",
      "type": "text",
      "data-vv-as": "Cidade"
    },
    domProps: {
      "value": (_vm.residence.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.residence, "city", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('data.residence.cidade')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.residence.cidade')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data[residence]][state]')
    }
  }, [_c('label', {
    attrs: {
      "for": "data.residence.state"
    }
  }, [_vm._v(_vm._s(_vm.state.label) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    key: _vm.residence.state,
    staticClass: "vueSelect",
    attrs: {
      "options": _vm.state.options,
      "label": "text",
      "filterable": true,
      "reduce": function (x) { return x.id; },
      "name": "data[residence]][state]",
      "id": _vm.state.id,
      "placeholder": _vm.state.placeholder,
      "data-vv-as": _vm.state.label
    },
    model: {
      value: (_vm.residence.state),
      callback: function($$v) {
        _vm.$set(_vm.residence, "state", $$v)
      },
      expression: "residence.state"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    slot: "no-options"
  }, [_vm._v("Digite 3 ou mais caracteres para buscar")])]), _vm._v(" "), (_vm.errors.has('data[residence]][state]')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data[residence]][state]')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data[residence][walk]')
    }
  }, [_c('label', {
    attrs: {
      "for": "imovel_walk"
    }
  }, [_vm._v(_vm._s(_vm.flooring.label) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    key: _vm.residence.walk,
    staticClass: "vueSelect",
    attrs: {
      "options": _vm.flooring.options,
      "label": "text",
      "filterable": true,
      "reduce": function (x) { return x.id; },
      "name": "data[residence][walk]",
      "id": _vm.flooring.id,
      "placeholder": _vm.flooring.placeholder,
      "data-vv-as": _vm.flooring.label
    },
    model: {
      value: (_vm.residence.walk),
      callback: function($$v) {
        _vm.$set(_vm.residence, "walk", $$v)
      },
      expression: "residence.walk"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    slot: "no-options"
  }, [_vm._v("Digite 3 ou mais caracteres para buscar")])]), _vm._v(" "), (_vm.errors.has('data[residence][walk]')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data[residence][walk]')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data[residence][type_construction]')
    }
  }, [_c('label', {
    attrs: {
      "for": "typeConstruction"
    }
  }, [_vm._v(_vm._s(_vm.typesConstruction.label) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    key: _vm.residence.type_construction,
    staticClass: "vueSelect",
    attrs: {
      "options": _vm.typesConstruction.options,
      "label": "text",
      "filterable": true,
      "reduce": function (x) { return x.id; },
      "name": "data[residence][type_construction]",
      "id": _vm.typesConstruction.id,
      "placeholder": _vm.typesConstruction.placeholder,
      "data-vv-as": _vm.typesConstruction.label
    },
    model: {
      value: (_vm.residence.type_construction),
      callback: function($$v) {
        _vm.$set(_vm.residence, "type_construction", $$v)
      },
      expression: "residence.type_construction"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    slot: "no-options"
  }, [_vm._v("Digite 3 ou mais caracteres para buscar")])]), _vm._v(" "), (_vm.errors.has('data[residence][type_construction]')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data[residence][type_construction]')))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data[residence][location]')
    }
  }, [_c('label', {
    attrs: {
      "for": "location"
    }
  }, [_vm._v(_vm._s(_vm.locations.label) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    key: _vm.residence.location,
    staticClass: "vueSelect",
    attrs: {
      "options": _vm.locations.options,
      "label": "text",
      "filterable": true,
      "reduce": function (x) { return x.id; },
      "name": "data[residence][location]",
      "id": _vm.locations.id,
      "placeholder": _vm.locations.placeholder,
      "data-vv-as": _vm.locations.label
    },
    model: {
      value: (_vm.residence.location),
      callback: function($$v) {
        _vm.$set(_vm.residence, "location", $$v)
      },
      expression: "residence.location"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    slot: "no-options"
  }, [_vm._v("Digite 3 ou mais caracteres para buscar")])]), _vm._v(" "), (_vm.errors.has('data[residence][location]')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data[residence][location]')))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.activityList), function(activity) {
    return (_vm.render_cnae_select) ? _c('div', {
      key: activity.company,
      staticClass: "col-xs-6 col-md-6"
    }, [_c('div', {
      staticClass: "form-group",
      class: {
        'has-error': _vm.errors.has(("data[residence][activity_cnae_company][" + (activity.company) + "]"))
      }
    }, [_c('label', {
      attrs: {
        "for": "activity_cnae_company"
      }
    }, [_vm._v("Atividades CNAE da " + _vm._s(_vm.capitalizeFirstLetter(activity.description))), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("*")])]), _vm._v(" "), _c('select2', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({
          rules: {
            required: true
          }
        }),
        expression: "{ rules: { required: true } }"
      }],
      attrs: {
        "options": activity.cnaeOptions,
        "name": ("data[residence][activity_cnae_company][" + (activity.company) + "]"),
        "id": activity.company,
        "placeholder": "Carregando...",
        "data-vv-as": "Atividade CNAE",
        "ajax": _vm.searchCnaeNew(activity.company)
      },
      model: {
        value: (activity.value),
        callback: function($$v) {
          _vm.$set(activity, "value", $$v)
        },
        expression: "activity.value"
      }
    }), _vm._v(" "), (_vm.errors.has(("data[residence][activity_cnae_company][" + (activity.company) + "]"))) ? _c('div', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.errors.first(("data[residence][activity_cnae_company][" + (activity.company) + "]"))))]) : _vm._e()], 1)]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "row m-0"
  }, [_c('label', [_vm._v("Equipamentos de segurança")]), _vm._v(" "), _c('div', {
    staticClass: "switch-border col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.residence.local_alarm')
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.residence.local_alarm),
      expression: "residence.local_alarm"
    }],
    attrs: {
      "type": "checkbox",
      "name": "data.residence.local_alarm"
    },
    domProps: {
      "checked": Array.isArray(_vm.residence.local_alarm) ? _vm._i(_vm.residence.local_alarm, null) > -1 : (_vm.residence.local_alarm)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.residence.local_alarm,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.residence.local_alarm = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.residence.local_alarm = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.residence, "local_alarm", $$c)
        }
      }
    }
  }), _c('span', {
    staticClass: "slider round"
  }), _c('span', {
    staticClass: "absolute-no"
  }, [_vm._v("Alarme local")])])]), _vm._v(" "), (_vm.errors.has('data.residence.local_alarm')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.residence.local_alarm')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.residence.security_24h')
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.residence.security_24h),
      expression: "residence.security_24h"
    }],
    attrs: {
      "type": "checkbox",
      "name": "data.residence.security_24h"
    },
    domProps: {
      "checked": Array.isArray(_vm.residence.security_24h) ? _vm._i(_vm.residence.security_24h, null) > -1 : (_vm.residence.security_24h)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.residence.security_24h,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.residence.security_24h = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.residence.security_24h = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.residence, "security_24h", $$c)
        }
      }
    }
  }), _c('span', {
    staticClass: "slider round"
  }), _c('span', {
    staticClass: "absolute-no"
  }, [_vm._v("Vigilância 24 horas")])])]), _vm._v(" "), (_vm.errors.has('data.residence.security_24h')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.residence.security_24h')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.residence.grid_tetra_lock')
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.residence.grid_tetra_lock),
      expression: "residence.grid_tetra_lock"
    }],
    attrs: {
      "type": "checkbox",
      "name": "data.residence.grid_tetra_lock"
    },
    domProps: {
      "checked": Array.isArray(_vm.residence.grid_tetra_lock) ? _vm._i(_vm.residence.grid_tetra_lock, null) > -1 : (_vm.residence.grid_tetra_lock)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.residence.grid_tetra_lock,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.residence.grid_tetra_lock = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.residence.grid_tetra_lock = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.residence, "grid_tetra_lock", $$c)
        }
      }
    }
  }), _c('span', {
    staticClass: "slider round"
  }), _c('span', {
    staticClass: "absolute-no"
  }, [_vm._v("Grade e fechadura tetra")])])]), _vm._v(" "), (_vm.errors.has('data.residence.grid_tetra_lock')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.residence.grid_tetra_lock')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.residence.closed_circuit')
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.residence.closed_circuit),
      expression: "residence.closed_circuit"
    }],
    attrs: {
      "type": "checkbox",
      "name": "data.residence.closed_circuit"
    },
    domProps: {
      "checked": Array.isArray(_vm.residence.closed_circuit) ? _vm._i(_vm.residence.closed_circuit, null) > -1 : (_vm.residence.closed_circuit)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.residence.closed_circuit,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.residence.closed_circuit = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.residence.closed_circuit = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.residence, "closed_circuit", $$c)
        }
      }
    }
  }), _c('span', {
    staticClass: "slider round"
  }), _c('span', {
    staticClass: "absolute-no"
  }, [_vm._v("Circuito fechado de CFTV")])])]), _vm._v(" "), (_vm.errors.has('data.residence.closed_circuit')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.residence.closed_circuit')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.residence.monitored_alarm]')
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.residence.monitored_alarm),
      expression: "residence.monitored_alarm"
    }],
    attrs: {
      "type": "checkbox",
      "name": "data.residence.monitored_alarm"
    },
    domProps: {
      "checked": Array.isArray(_vm.residence.monitored_alarm) ? _vm._i(_vm.residence.monitored_alarm, null) > -1 : (_vm.residence.monitored_alarm)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.residence.monitored_alarm,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.residence.monitored_alarm = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.residence.monitored_alarm = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.residence, "monitored_alarm", $$c)
        }
      }
    }
  }), _c('span', {
    staticClass: "slider round"
  }), _c('span', {
    staticClass: "absolute-no"
  }, [_vm._v("Alarme monitorado")])])]), _vm._v(" "), (_vm.errors.has('data.residence.monitored_alarm')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.residence.monitored_alarm')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.residence.infrared_sensor')
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.residence.infrared_sensor),
      expression: "residence.infrared_sensor"
    }],
    attrs: {
      "type": "checkbox",
      "name": "data.residence.infrared_sensor"
    },
    domProps: {
      "checked": Array.isArray(_vm.residence.infrared_sensor) ? _vm._i(_vm.residence.infrared_sensor, null) > -1 : (_vm.residence.infrared_sensor)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.residence.infrared_sensor,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.residence.infrared_sensor = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.residence.infrared_sensor = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.residence, "infrared_sensor", $$c)
        }
      }
    }
  }), _c('span', {
    staticClass: "slider round"
  }), _c('span', {
    staticClass: "absolute-no"
  }, [_vm._v("Sensor infravermelho")])])]), _vm._v(" "), (_vm.errors.has('data.residence.infrared_sensor')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.residence.infrared_sensor')))]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-0"
  }, [_c('label', [_vm._v("Equipamentos contra incêndio")]), _vm._v(" "), _c('div', {
    staticClass: "switch-border col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.residence.hydrant')
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.residence.hydrant),
      expression: "residence.hydrant"
    }],
    attrs: {
      "type": "checkbox",
      "name": "data.residence.hydrant"
    },
    domProps: {
      "checked": Array.isArray(_vm.residence.hydrant) ? _vm._i(_vm.residence.hydrant, null) > -1 : (_vm.residence.hydrant)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.residence.hydrant,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.residence.hydrant = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.residence.hydrant = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.residence, "hydrant", $$c)
        }
      }
    }
  }), _c('span', {
    staticClass: "slider round"
  }), _c('span', {
    staticClass: "absolute-no"
  }, [_vm._v("Hidrante")])])]), _vm._v(" "), (_vm.errors.has('data.residence.hydrant')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.residence.hydrant')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.residence.smoke_detector')
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.residence.smoke_detector),
      expression: "residence.smoke_detector"
    }],
    attrs: {
      "type": "checkbox",
      "name": "data.residence.smoke_detector"
    },
    domProps: {
      "checked": Array.isArray(_vm.residence.smoke_detector) ? _vm._i(_vm.residence.smoke_detector, null) > -1 : (_vm.residence.smoke_detector)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.residence.smoke_detector,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.residence.smoke_detector = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.residence.smoke_detector = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.residence, "smoke_detector", $$c)
        }
      }
    }
  }), _c('span', {
    staticClass: "slider round"
  }), _c('span', {
    staticClass: "absolute-no"
  }, [_vm._v("Detector de fumaça")])])]), _vm._v(" "), (_vm.errors.has('data.residence.smoke_detector')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.residence.smoke_detector')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.residence.fire_brigade')
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.residence.fire_brigade),
      expression: "residence.fire_brigade"
    }],
    attrs: {
      "type": "checkbox",
      "name": "data.residence.fire_brigade"
    },
    domProps: {
      "checked": Array.isArray(_vm.residence.fire_brigade) ? _vm._i(_vm.residence.fire_brigade, null) > -1 : (_vm.residence.fire_brigade)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.residence.fire_brigade,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.residence.fire_brigade = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.residence.fire_brigade = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.residence, "fire_brigade", $$c)
        }
      }
    }
  }), _c('span', {
    staticClass: "slider round"
  }), _c('span', {
    staticClass: "absolute-no"
  }, [_vm._v("Brigada de incêndio")])])]), _vm._v(" "), (_vm.errors.has('data.residence.fire_brigade')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.residence.fire_brigade')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.residence.extinguisher')
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.residence.extinguisher),
      expression: "residence.extinguisher"
    }],
    attrs: {
      "type": "checkbox",
      "name": "data.residence.extinguisher"
    },
    domProps: {
      "checked": Array.isArray(_vm.residence.extinguisher) ? _vm._i(_vm.residence.extinguisher, null) > -1 : (_vm.residence.extinguisher)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.residence.extinguisher,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.residence.extinguisher = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.residence.extinguisher = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.residence, "extinguisher", $$c)
        }
      }
    }
  }), _c('span', {
    staticClass: "slider round"
  }), _c('span', {
    staticClass: "absolute-no"
  }, [_vm._v("Extintor")])])]), _vm._v(" "), (_vm.errors.has('data.residence.extinguisher')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.residence.extinguisher')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('data.residence.sprinkler')
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.residence.sprinkler),
      expression: "residence.sprinkler"
    }],
    attrs: {
      "type": "checkbox",
      "name": "data.residence.sprinkler"
    },
    domProps: {
      "checked": Array.isArray(_vm.residence.sprinkler) ? _vm._i(_vm.residence.sprinkler, null) > -1 : (_vm.residence.sprinkler)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.residence.sprinkler,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.residence.sprinkler = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.residence.sprinkler = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.residence, "sprinkler", $$c)
        }
      }
    }
  }), _c('span', {
    staticClass: "slider round"
  }), _c('span', {
    staticClass: "absolute-no"
  }, [_vm._v("Sprinkler")])])]), _vm._v(" "), (_vm.errors.has('data.residence.sprinkler')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('data.residence.sprinkler')))]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "data.residence.zip_code"
    }
  }, [_vm._v("CEP "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "imovel_logradouro"
    }
  }, [_vm._v("Endereço "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "imovel_numero"
    }
  }, [_vm._v("Número "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "imovel_bairro"
    }
  }, [_vm._v("Bairro "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "imovel_cidade"
    }
  }, [_vm._v("Cidade "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b05977e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/enterprise/modules/Residence/FormPartialEnterprise.vue
// module id = 338
// module chunks = 0